import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import localeData from 'dayjs/plugin/localeData';
import minMax from 'dayjs/plugin/minMax';

// Load locale data plugin
dayjs.extend(localeData);
dayjs.extend(minMax);
// Extend dayjs with all required plugins
dayjs.extend(advancedFormat);
dayjs.extend(utc);
dayjs.extend(customParseFormat);

export const configuredDayjs = dayjs;
